import React from 'react'
import { connect } from 'react-redux'
import { Field, getFormValues, change } from 'redux-form'
import { Button, Icon, Modal } from 'semantic-ui-react'

import FieldInput, { InputType as type } from 'components/SemanticForm'
import { StdCard, DivText } from 'components'
import { Cont, TableData } from './styled'

const ContactComponent = (props) => {

  const { 
    valueForm,
    change,
    // props
    isEdit = false
  } = props

  const [showAlertEmail, setShowAlertEmail] = React.useState(false)

  const onEmailFocusOut = (email) => {
    if (email) {
      if (email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
        var emailDuplicate = false
        if (valueForm.contacts.filter(u => u.email == email).length>1) emailDuplicate = true
        if (emailDuplicate) {
          setShowAlertEmail(true)
          change('formBGCompany','isContactValid',false)
        }else{
          change('formBGCompany','isContactValid',true)
        }
      }else{
        setShowAlertEmail(true)
        change('formBGCompany','isContactValid',false)
      }
    }
  }

  return (
    <StdCard title={<span name='contacts' className='stepTitle'>Customer/Vendor Contact</span>}>
      <Cont>
        <Field 
          name="contactsAlert"
          component={FieldInput}
          type={type.text}
          dummy
        />
        {isEdit?
        <Button 
          type='button'
          content='Add' 
          color='blue' 
          icon='plus' 
          labelPosition='right'
          style={{ marginRight: '5px', maxWidth:'7rem' }}
          onClick={()=>{
            change('formBGCompany',`contacts[${valueForm.contacts.length}].deleted`,false)
          }}
        />:null}
        <div style={{height:'1rem'}}/>
        <div style={{overflowX:'auto'}}>
          <TableData>
            <thead>
              <tr>
                {isEdit?<th style={{width:'3rem'}}>Action</th>:null}
                <th style={{minWidth:'15rem'}}>First Name</th>
                <th style={{minWidth:'15rem'}}>Last Name</th>
                <th style={{minWidth:'15rem'}}>Email</th>
                <th>Mobile</th>
                <th>Telephone</th>
                <th>Extension</th>
              </tr>
            </thead>
            <tbody>
            {           
              valueForm.contacts.map((item,index)=>{
                if(item.deleted) return null
                return(
                  <tr>
                    {isEdit?<td>
                      <Icon 
                        name='trash alternate' 
                        color='red'
                        onClick={()=>{
                          let cloneContacts = JSON.parse(JSON.stringify(valueForm.contacts))
                          if(item.id){
                            cloneContacts[index].deleted = true
                          }else{
                            cloneContacts.splice(index, 1)
                          }
                          change('formBGCompany','contacts',cloneContacts)
                        }}
                      />
                    </td>:null}
                    <td>
                      <Field 
                        name={`contacts[${index}].firstName`}
                        component={FieldInput}
                        type={type.text}
                        editable={isEdit}
                        style={{marginBottom:'0px'}}
                        containerStyle={{marginRight:'0px'}}
                        placeHolder='Require'
                        noBorder={!isEdit}
                      />
                    </td>
                    <td>
                      <Field 
                        name={`contacts[${index}].lastName`}
                        component={FieldInput}
                        type={type.text}
                        editable={isEdit}
                        style={{marginBottom:'0px'}}
                        containerStyle={{marginRight:'0px'}}
                        placeHolder='Require'
                        noBorder={!isEdit}
                      />
                    </td>
                    <td>
                      <Field 
                        name={`contacts[${index}].email`}
                        component={FieldInput}
                        type={type.text}
                        editable={isEdit}
                        style={{marginBottom:'0px'}}
                        containerStyle={{marginRight:'0px'}}
                        placeHolder='Require'
                        onBlur={(e, value) => {
                          onEmailFocusOut(value)
                        }}
                        noBorder={!isEdit}
                      />
                    </td>
                    <td>
                      <Field 
                        name={`contacts[${index}].mobile`}
                        component={FieldInput}
                        type={type.number}
                        editable={isEdit}
                        style={{marginBottom:'0px'}}
                        containerStyle={{marginRight:'0px'}}
                        decimalScale={0}
                        thousandSeparator={false}
                        formatValue="###-###-####"
                        noBorder={!isEdit}
                      />
                    </td>
                    <td>
                      <Field 
                        name={`contacts[${index}].telephone`}
                        component={FieldInput}
                        type={type.number}
                        editable={isEdit}
                        style={{marginBottom:'0px'}}
                        containerStyle={{marginRight:'0px'}}
                        decimalScale={0}
                        thousandSeparator={false}
                        formatValue="##-###-####"
                        noBorder={!isEdit}
                      />
                    </td>
                    <td>
                      <Field 
                        name={`contacts[${index}].extension`}
                        component={FieldInput}
                        type={type.number}
                        editable={isEdit}
                        style={{marginBottom:'0px'}}
                        containerStyle={{marginRight:'0px'}}
                        decimalScale={0}
                        thousandSeparator={false}
                        formatValue="####"
                        noBorder={!isEdit}
                      />
                    </td>
                  </tr>
                )
              })
            }
            </tbody>
          </TableData>
        </div>
        <Modal
          open={showAlertEmail}
          header='Alert'
          size= 'mini'
          content='Email format is not correct.'
          actions={[{ key: 'Close', content: 'Close', onClick:()=>setShowAlertEmail(false) }]}
        />
      </Cont>
    </StdCard>
  )
}

const mapStateToProps = (state, props) => {
  return {
    valueForm: getFormValues('formBGCompany')(state) || {contacts:[]},
  }
}

const mapDispatchToProps = {
  change
}

export default connect(mapStateToProps, mapDispatchToProps)(ContactComponent)
